module.exports = __webpack_public_path__ + "static/media/pick11-cricketplayer.111b013f.png";